import { render, staticRenderFns } from "./PartnerView.vue?vue&type=template&id=fdbdabb2&scoped=true"
import script from "./PartnerView.vue?vue&type=script&lang=js"
export * from "./PartnerView.vue?vue&type=script&lang=js"
import style0 from "./PartnerView.vue?vue&type=style&index=0&id=fdbdabb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbdabb2",
  null
  
)

export default component.exports